import { createContext, useContext } from 'react';

/**
 * An app-document element block badges render into instead of the page
 * iframe. The studio canvas provides its viewport: a badge inside the iframe
 * is scaled with the artboard and cropped at its edges, while one in the
 * viewport keeps its on-screen size and can overhang the artboard, clipped
 * only by the canvas itself. `null` (the default) keeps badges in the iframe.
 */
export const OverlayHostContext = createContext<HTMLElement | null>(null);

export const useOverlayHost = () => useContext(OverlayHostContext);
